// import html2pdf from "html2pdf.js";

// if (document.querySelectorAll(".js-btn-print-pdf").length > 0) {
//   const btnPrints = document.querySelectorAll(".js-btn-print-pdf");
//   for (const btnPrint of btnPrints) {
//     btnPrint.addEventListener("click", (e) => {
//       e.preventDefault();
//       document.querySelector("#loader").style.display = "block";
//       console.log(btnPrint.getAttribute("href"));

//       fetch(btnPrint.getAttribute("href"))
//         .then(function (response) {
//           // The API call was successful!
//           return response.text();
//         })
//         .then(function (html) {
//           // Convert the HTML string into a document object
//           let parser = new DOMParser();
//           let htmlDoc = parser.parseFromString(html, "text/html");

//           let elementToPrints = htmlDoc.querySelectorAll(".js-pdf-to-print");
//           let elementToString = "";
//           for (const elementToPrint of elementToPrints) {
//             elementToString += elementToPrint.outerHTML;
//           }
//           // elementToString += '</div>';

//           console.log(elementToString);

//           // var element = document.getElementById('element-to-print');
//           var opt = {
//             margin: [20, 10],
//             filename: document.querySelector("title").innerHTML + ".pdf",
//             image: { type: "jpeg", quality: 0.95 },
//             html2canvas: { scale: 2, windowWidth: 1920 },
//             jsPDF: { unit: "pt", format: "a4", orientation: "portrait" }, // userUnit: 300
//             pagebreak: { mode: ["css"] }, // 'avoid-all'
//           };

//           // New Promise-based usage:
//           html2pdf()
//             .set(opt)
//             .from(elementToString)
//             .save()
//             .then(function () {
//               document.querySelector("#loader").style.display = "none";
//             });
//         })
//         .catch(function (err) {
//           // There was an error
//           console.warn("Something went wrong.", err);
//         });
import { jsPDF } from "jspdf";

const language = document.querySelector("html").getAttribute("lang");
const labelsByLang = {
  fr: { ingredients: "Ingrédients", preparation: "Préparation" },
  en: { ingredients: "Ingredients", preparation: "Preparation" },
  de: { ingredients: "Zutaten", preparation: "Zubereitung" },
};
const pdfLabels = labelsByLang[language] || labelsByLang.fr;

const sanitizeText = (value) => {
  if (!value) return "";
  const fractionMap = {
    "⅛": "1/8",
    "¼": "1/4",
    "⅓": "1/3",
    "⅜": "3/8",
    "½": "1/2",
    "⅝": "5/8",
    "⅔": "2/3",
    "¾": "3/4",
    "⅞": "7/8",
    "⅕": "1/5",
    "⅖": "2/5",
    "⅗": "3/5",
    "⅘": "4/5",
    "⅙": "1/6",
    "⅚": "5/6",
  };
  return value
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/[–—]/g, "-")
    .replace(/…/g, "...")
    .replace(/\u00A0/g, " ")
    .replace(/\u202F/g, " ")
    .replace(/[⅛¼⅓⅜½⅝⅔¾⅞⅕⅖⅗⅘⅙⅚]/g, (match) => fractionMap[match] || match)
    .replace(/[^\u0000-\u00FF]/g, "");
};

const stripHtml = (value) => {
  if (!value) return "";
  const parser = new DOMParser();
  const doc = parser.parseFromString(value, "text/html");
  return sanitizeText((doc.body.textContent || "").trim());
};

const toTextLines = (doc, text, maxWidth) => doc.splitTextToSize(text, maxWidth).filter((line) => line.trim().length > 0);

const getArticleBlocks = (article = [], choice) => article.filter((block) => block && block._choice === choice);

const getKeypointLabel = (iconHtml = "") => {
  if (iconHtml.includes("clock")) {
    return "Durée";
  } else if (iconHtml.includes("users")) {
    return "Nombre de personnes";
  } else if (iconHtml.includes("signal-bars")) {
    return "Difficulté";
  } else {
    return "Info";
  }
};

const getKeypointSvg = (iconHtml = "") => {
  if (iconHtml.includes("clock")) {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#8dbd1f" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>`;
  }
  if (iconHtml.includes("users")) {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#8dbd1f" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3"/><path d="M3 20c0-3.3 2.7-6 6-6"/><circle cx="17" cy="10" r="2.5"/><path d="M14 20c0-2.8 2.2-5 5-5"/></svg>`;
  }
  if (iconHtml.includes("signal-bars")) {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#8dbd1f" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20v-3"/><path d="M9 20v-6"/><path d="M14 20v-9"/><path d="M19 20v-12"/></svg>`;
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#8dbd1f"><circle cx="12" cy="12" r="3"/></svg>`;
};

const normalizeKeypointValue = (label, value) => {
  if (!value) return "";
  const trimmed = value.trim();
  if (label !== "Durée") return trimmed;
  const hasUnit = /min|minute|h|heure/i.test(trimmed);
  const hasDigits = /\d/.test(trimmed);
  if (hasDigits && !hasUnit) {
    return `${trimmed} min`;
  }
  return trimmed;
};

const keypointIconCache = new Map();

const getKeypointIconImage = async (iconHtml = "", size = 12) => {
  const svg = getKeypointSvg(iconHtml);
  const cacheKey = `${svg}-${size}`;
  if (keypointIconCache.has(cacheKey)) {
    return keypointIconCache.get(cacheKey);
  }

  const svgBlob = new Blob([svg], { type: "image/svg+xml" });
  const svgUrl = URL.createObjectURL(svgBlob);
  const image = await new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = svgUrl;
  });
  URL.revokeObjectURL(svgUrl);

  const canvas = document.createElement("canvas");
  const scale = 2;
  canvas.width = size * scale;
  canvas.height = size * scale;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  const dataUrl = canvas.toDataURL("image/png");
  const result = { dataUrl, format: "PNG" };
  keypointIconCache.set(cacheKey, result);
  return result;
};

const toAbsoluteUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${window.location.origin}${url}`;
};

const loadImageData = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Image fetch failed with status ${response.status}`);
  }
  const blob = await response.blob();
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  const size = await new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = reject;
    img.src = dataUrl;
  });

  const format = dataUrl.startsWith("data:image/png") ? "PNG" : "JPEG";
  return { dataUrl, width: size.width, height: size.height, format };
};

const loadCoverImageData = async (url, targetWidth, targetHeight, radius = 0) => {
  const { dataUrl, width, height } = await loadImageData(url);
  const img = await new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = dataUrl;
  });

  const scale = Math.max(targetWidth / width, targetHeight / height);
  const cropWidth = targetWidth / scale;
  const cropHeight = targetHeight / scale;
  const cropX = (width - cropWidth) / 2;
  const cropY = (height - cropHeight) / 2;

  const canvas = document.createElement("canvas");
  canvas.width = Math.round(targetWidth * 4);
  canvas.height = Math.round(targetHeight * 4);
  const ctx = canvas.getContext("2d");
  const radiusPx = Math.max(0, radius * 4);

  if (radiusPx > 0) {
    const w = canvas.width;
    const h = canvas.height;
    ctx.beginPath();
    ctx.moveTo(radiusPx, 0);
    ctx.lineTo(w - radiusPx, 0);
    ctx.quadraticCurveTo(w, 0, w, radiusPx);
    ctx.lineTo(w, h - radiusPx);
    ctx.quadraticCurveTo(w, h, w - radiusPx, h);
    ctx.lineTo(radiusPx, h);
    ctx.quadraticCurveTo(0, h, 0, h - radiusPx);
    ctx.lineTo(0, radiusPx);
    ctx.quadraticCurveTo(0, 0, radiusPx, 0);
    ctx.closePath();
    ctx.clip();
  }

  ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, canvas.width, canvas.height);

  const hasRadius = radiusPx > 0;
  return {
    dataUrl: canvas.toDataURL(hasRadius ? "image/png" : "image/jpeg", 0.92),
    format: hasRadius ? "PNG" : "JPEG",
  };
};

if (document.querySelectorAll(".js-btn-print-pdf").length > 0) {
  const btnPrints = document.querySelectorAll(".js-btn-print-pdf");
  for (const btnPrint of btnPrints) {
    btnPrint.addEventListener("click", async (e) => {
      e.preventDefault();
      const loader = document.querySelector("#loader");
      if (loader) loader.style.display = "block";

      const idBlog = btnPrint.dataset.idblog;
      if (!idBlog) {
        console.warn("Missing data-idblog on print button.");
        if (loader) loader.style.display = "none";
        return;
      }

      try {
        const response = await fetch(`/${language}/json-blog?idblog=${idBlog}`);
        if (!response.ok) {
          throw new Error(`Blog fetch failed with status ${response.status}`);
        }
        const data = await response.json();
        const blog = Array.isArray(data) ? data[0] : data;
        if (!blog) {
          throw new Error("Blog data is empty.");
        }

        const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const marginX = 8;
        const marginY = 8;
        const contentWidth = pageWidth - marginX * 2;
        let cursorY = marginY;

        const applyPageBackground = () => {
          // doc.setFillColor(246, 241, 236);
          doc.setFillColor(255, 255, 255);
          doc.rect(0, 0, pageWidth, pageHeight, "F");
        };

        applyPageBackground();

        const baseColumnGap = 6;
        const columnWidth = (contentWidth - baseColumnGap) / 2;
        const columnPadding = 4;
        const columnRadius = 4;
        const sectionBackground = [255, 255, 255];

        const ensureSpace = (height) => {
          if (cursorY + height > pageHeight - marginY) {
            doc.addPage();
            applyPageBackground();
            cursorY = marginY;
          }
        };

        const writeBlock = (lines, fontSize = 11, lineHeight = 5) => {
          doc.setFontSize(fontSize);
          for (const line of lines) {
            ensureSpace(lineHeight);
            doc.text(line, marginX, cursorY);
            cursorY += lineHeight;
          }
        };

        const keypoints = Array.isArray(blog.keypoints) ? blog.keypoints : [];
        const headerTextWidth = contentWidth;

        const title = stripHtml(blog.title);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        writeBlock(toTextLines(doc, title.toUpperCase(), headerTextWidth), 18, 9);
        doc.setFont("helvetica", "normal");
        cursorY += 0;

        const descriptionIntro = stripHtml(blog.descriptionIntro);
        doc.setFontSize(10);
        if (descriptionIntro) {
          writeBlock(toTextLines(doc, descriptionIntro, headerTextWidth), 10, 5);
          cursorY += 4;
        }

        // const meta = stripHtml(blog.meta);
        // if (meta) {
        //   writeBlock(toTextLines(doc, meta, headerTextWidth), 10, 5);
        //   cursorY += 2;
        // }

        if (keypoints.length) {
          doc.setFontSize(10.5);
          doc.setTextColor(60);
          // const rowTop = cursorY + 1;
          const rowTop = cursorY - 5;
          const rowHeight = 12;
          const columns = Math.min(3, keypoints.length);
          const cellWidth = contentWidth / columns;

          for (let i = 0; i < columns; i += 1) {
            const item = keypoints[i];
            const label = getKeypointLabel(item?.icon || "");
            const rawValue = stripHtml(item?.text || "");
            const value = normalizeKeypointValue(label, rawValue);
            if (!value) continue;
            const icon = await getKeypointIconImage(item?.icon || "", 10);
            const iconSize = 5;
            const cellX = marginX + cellWidth * i;
            doc.addImage(icon.dataUrl, icon.format, cellX, rowTop - 1.5, iconSize, iconSize);
            const textLines = toTextLines(doc, value, cellWidth - iconSize - 4);
            doc.text(textLines[0] || "", cellX + iconSize + 2, rowTop + 2.2);
          }

          doc.setTextColor(0);
          cursorY += 2;
        }

        const articleBlocks = Array.isArray(blog.article) ? blog.article : [];
        const ingredientGroups = [];
        articleBlocks.forEach((block, index) => {
          if (block?._choice !== "ingredients") return;
          const prevBlock = articleBlocks[index - 1];
          const prevTitle = prevBlock?._choice === "text" ? stripHtml(prevBlock.title) : "";
          const prevSubtitle = prevBlock?._choice === "text" ? stripHtml(prevBlock.subtitle) : "";
          const prevText = prevBlock?._choice === "text" ? stripHtml(prevBlock.text) : "";
          const heading = prevTitle || prevSubtitle;
          const title = heading && !prevText ? heading : "";
          ingredientGroups.push({ title, items: block?.ingredient || [] });
        });

        const preparationBlocks = getArticleBlocks(blog.article, "preparation");
        const preparationSteps = preparationBlocks.flatMap((block) => block?.stepPreparation || []);

        const heroImageUrl = toAbsoluteUrl(blog.image?.[0]?.url);
        const ingredientsGap = 4;
        const imageBlockWidth = contentWidth * 0.6 - ingredientsGap / 2;
        const ingredientsBlockWidth = contentWidth - imageBlockWidth - ingredientsGap;
        const ingredientPadding = 4;
        const ingredientHeaderBaselineOffset = 2;
        const ingredientHeadingLineHeight = 6;
        const ingredientGroupLineHeight = 4;
        const ingredientItemLineHeight = 4.8;
        const ingredientBottomPadding = ingredientPadding;

        const bulletSymbol = "-";
        const bulletWidth = (() => {
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          return doc.getTextWidth(`${bulletSymbol} `);
        })();

        const measureIngredientHeight = () => {
          let relativeCursor = ingredientPadding + ingredientHeaderBaselineOffset;

          doc.setFont("helvetica", "bold");
          doc.setFontSize(10);
          relativeCursor += ingredientHeadingLineHeight;

          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          if (ingredientGroups.length) {
            ingredientGroups.forEach((group, groupIndex) => {
              if (groupIndex > 0 && group.title) {
                doc.setFont("helvetica", "bold");
                doc.setFontSize(10);
                const titleLines = toTextLines(doc, stripHtml(group.title), ingredientsBlockWidth - ingredientPadding * 2);
                relativeCursor += titleLines.length * ingredientGroupLineHeight;
                doc.setFont("helvetica", "normal");
                doc.setFontSize(10);
                relativeCursor += 1;
              }

              group.items.forEach((item) => {
                const itemText = stripHtml(item.text);
                if (!itemText) return;
                const textWidthAvailable = ingredientsBlockWidth - ingredientPadding * 2 - bulletWidth;
                const lines = toTextLines(doc, itemText, textWidthAvailable);
                relativeCursor += lines.length * ingredientItemLineHeight;
              });
            });
          }

          return Math.max(0, relativeCursor + ingredientBottomPadding);
        };

        const minIngredientsHeight = 60;
        const calculatedIngredientsHeight = Math.max(minIngredientsHeight, measureIngredientHeight());
        const ingredientsBlockHeight = calculatedIngredientsHeight;

        ensureSpace(ingredientsBlockHeight + 6);

        if (heroImageUrl) {
          try {
            const heroImage = await loadCoverImageData(heroImageUrl, imageBlockWidth, ingredientsBlockHeight, 4);
            doc.addImage(heroImage.dataUrl, heroImage.format, marginX, cursorY, imageBlockWidth, ingredientsBlockHeight);
          } catch (imageError) {
            console.warn("Hero image failed to load.", imageError);
          }
        }

        const ingredientsBoxX = marginX + imageBlockWidth + ingredientsGap;
        doc.setFillColor(...sectionBackground);
        doc.setDrawColor(246, 241, 236);
        doc.setLineWidth(0.7);
        doc.roundedRect(ingredientsBoxX, cursorY, ingredientsBlockWidth, ingredientsBlockHeight, columnRadius, columnRadius, "FD");

        let ingredientCursorY = cursorY + ingredientPadding + 2;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text(pdfLabels.ingredients, ingredientsBoxX + ingredientPadding, ingredientCursorY);
        doc.setFont("helvetica", "normal");
        ingredientCursorY += 6;
        if (ingredientGroups.length) {
          const availableTextWidth = ingredientsBlockWidth - ingredientPadding * 2 - bulletWidth;
          ingredientGroups.forEach((group, groupIndex) => {
            if (groupIndex > 0 && group.title) {
              doc.setFont("helvetica", "bold");
              doc.setFontSize(10);
              doc.setTextColor(90);
              const titleLines = toTextLines(doc, stripHtml(group.title), ingredientsBlockWidth - ingredientPadding * 2);
              titleLines.forEach((textLine) => {
                if (ingredientCursorY + ingredientGroupLineHeight > cursorY + ingredientsBlockHeight - ingredientPadding) {
                  return;
                }
                doc.text(textLine, ingredientsBoxX + ingredientPadding, ingredientCursorY);
                ingredientCursorY += ingredientGroupLineHeight;
              });
              doc.setFont("helvetica", "normal");
              doc.setFontSize(10);
              doc.setTextColor(0);
              ingredientCursorY += 1;
            }

            group.items.forEach((item) => {
              const itemText = stripHtml(item.text);
              if (!itemText) return;
              const bulletX = ingredientsBoxX + ingredientPadding;
              const textX = bulletX + bulletWidth;
              const lines = toTextLines(doc, itemText, availableTextWidth);

              for (const [lineIndex, textLine] of lines.entries()) {
                if (ingredientCursorY + ingredientItemLineHeight > cursorY + ingredientsBlockHeight - ingredientPadding + 6) {
                  break;
                }
                if (lineIndex === 0) {
                  doc.text(bulletSymbol, bulletX, ingredientCursorY);
                }
                doc.text(textLine, textX, ingredientCursorY);
                ingredientCursorY += ingredientItemLineHeight;
              }
            });
          });
        }

        cursorY += ingredientsBlockHeight + 4;

        const columnsTop = cursorY;
        const columnsHeight = pageHeight - columnsTop - marginY;
        const leftX = marginX;
        const prepColumnGap = 2;
        const prepColumnWidth = (contentWidth - prepColumnGap) / 2;
        const prepLeftX = leftX + columnPadding;
        const prepRightX = leftX + prepColumnWidth + prepColumnGap + columnPadding;
        const columnLimitY = columnsTop + columnsHeight - columnPadding;

        doc.setFillColor(...sectionBackground);
        doc.setDrawColor(246, 241, 236);
        doc.setLineWidth(0.7);
        doc.roundedRect(leftX, columnsTop, contentWidth, columnsHeight, columnRadius, columnRadius, "FD");

        const writeColumnText = (lines, x, y, fontSize, lineHeight, limitY) => {
          doc.setFontSize(fontSize);
          let cursor = y;
          for (const line of lines) {
            if (cursor + lineHeight > limitY) {
              break;
            }
            doc.text(line, x, cursor);
            cursor += lineHeight;
          }
          return cursor;
        };

        const renderStep = async (step, stepIndex, x, y, width, limitY) => {
          const thumbSize = 14;
          const gap = 2;
          const stepImageUrl = toAbsoluteUrl(step.image?.[0]?.url);
          const titleText = stripHtml(step.title);
          const descriptionText = stripHtml(step.description);
          const stepTitle = titleText ? `${stepIndex + 1}. ${titleText}` : `${stepIndex + 1}.`;
          const fullText = descriptionText ? `${stepTitle} ${descriptionText}` : stepTitle;
          const textX = stepImageUrl ? x + thumbSize + gap : x;
          const textWidth = width - (textX - x);

          const textLines = toTextLines(doc, fullText, textWidth);
          const firstLineHeight = 3.4;
          const nextLineHeight = 3.2;
          const textHeight = textLines.length > 0 ? firstLineHeight + Math.max(0, textLines.length - 1) * nextLineHeight : 0;
          const blockHeight = Math.max(thumbSize, textHeight);

          if (y + blockHeight > limitY) {
            return y;
          }

          if (stepImageUrl) {
            try {
              const thumb = await loadCoverImageData(stepImageUrl, thumbSize, thumbSize, 2);
              doc.addImage(thumb.dataUrl, thumb.format, x, y - 3, thumbSize, thumbSize);
            } catch (thumbError) {
              console.warn("Step image failed to load.", thumbError);
            }
          }

          // let textCursor = y + 1;
          let textCursor = y;
          if (textLines.length) {
            const firstLine = textLines[0];
            doc.setFontSize(8);
            if (firstLine.startsWith(stepTitle)) {
              const rest = firstLine.slice(stepTitle.length).trimStart();
              doc.setFont("helvetica", "bold");
              doc.text(stepTitle, textX, textCursor);
              if (rest) {
                const prefixWidth = doc.getTextWidth(`${stepTitle} `);
                doc.setFont("helvetica", "normal");
                doc.text(rest, textX + prefixWidth, textCursor);
              }
            } else {
              doc.setFont("helvetica", "bold");
              doc.text(firstLine, textX, textCursor);
            }
            textCursor += firstLineHeight;

            if (textLines.length > 1) {
              doc.setFont("helvetica", "normal");
              doc.setFontSize(8);
              textCursor = writeColumnText(textLines.slice(1), textX, textCursor, 8, nextLineHeight, limitY);
            }
          }

          return y + blockHeight + 4;
        };

        let leftCursor = columnsTop + columnPadding + 3;
        doc.setFont("helvetica", "bold");
        leftCursor = writeColumnText([pdfLabels.preparation], prepLeftX, leftCursor, 12, 7, columnLimitY);
        doc.setFont("helvetica", "normal");

        if (preparationSteps.length) {
          const steps = preparationSteps;
          const splitIndex = Math.ceil(steps.length / 2);
          for (let i = 0; i < splitIndex; i += 1) {
            leftCursor = await renderStep(steps[i], i, prepLeftX, leftCursor + 1, prepColumnWidth - columnPadding, columnLimitY + 10);
          }

          let rightCursor = columnsTop + columnPadding + 3;
          doc.setFont("helvetica", "bold");
          rightCursor = writeColumnText([""], prepRightX, rightCursor, 12, 7, columnLimitY);
          doc.setFont("helvetica", "normal");
          for (let i = splitIndex; i < steps.length; i += 1) {
            // rightCursor = await renderStep(steps[i], i, prepRightX - 10, rightCursor + 1, prepColumnWidth - columnPadding * 2, columnLimitY + 10);
            rightCursor = await renderStep(steps[i], i, prepRightX - 5, rightCursor + 1, prepColumnWidth - columnPadding, columnLimitY + 10);
          }
        }

        doc.save(`${title || "recette"}.pdf`);
      } catch (error) {
        console.warn("PDF generation failed.", error);
      } finally {
        if (loader) loader.style.display = "none";
      }
    });
  }
}
